var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"loading-mask",style:(_vm.maskStyles)},[_c('div',{staticClass:"loading-box"},[_c('div',{class:[_vm.type]}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }